import { Icon } from "@/components/common/icon/Icon";
import { useUserStore } from "@/modules/auth/store/user";
import {
  getPromoCapByCurrentRank,
  RANK_ORDER,
} from "@/modules/user/types/wallet";
import { useTranslation } from "react-i18next";

const PROMO_STEPS: Array<keyof typeof RANK_ORDER> = [
  "GOLD",
  "PLATINUM",
  "SAPPHIRE",
  "RUBY",
  "EMERALD",
];

const Promo = () => {
  const { t } = useTranslation();

  const { matchingBonus } = useUserStore();

  const currentRank = matchingBonus.rank.current.code;
  const promoTurnover = matchingBonus.promoTurnover;

  const currentIndex = Math.max(
    0,
    PROMO_STEPS.findIndex((r) => r === currentRank)
  );
  return (
    <>
      {PROMO_STEPS.map((step, idx) => {
        const isDone =
          RANK_ORDER[step] <= RANK_ORDER[currentRank] &&
          promoTurnover >= getPromoCapByCurrentRank(step);
        const isFuture = idx > currentIndex;

        const circleBg = isDone ? "bg-link" : "bg-bg";
        const iconType = isDone ? "check-fill" : "lock";
        const textCls =
          isFuture || !isDone ? "text-subtitle-text" : "text-text";

        return (
          <div key={step} className="relative w-full flex items-center gap-4">
            {/* up connector */}
            {idx > 0 && (
              <div
                className={`absolute w-2 h-[50%] -top-1.5 left-4 -z-10 ${circleBg}`}
              />
            )}

            {/* down connector */}
            {idx < PROMO_STEPS.length - 1 && (
              <div
                className={`absolute w-2 h-[50%] -bottom-1.5 left-4 -z-10 ${circleBg}`}
              />
            )}

            {/* circle */}
            <div
              className={`shrink-0 flex items-center justify-center ${circleBg} rounded-full w-10 h-10`}
            >
              <Icon
                type={iconType}
                className={isDone ? "fill-link w-10 h-10" : "fill-link w-6 h-6"}
              />
            </div>

            {/* card */}
            <div className="w-full flex items-center gap-4 px-5 py-3 bg-bg rounded-[0.75rem]">
              <p
                className={`text-[1.0625rem] leading-[1.375rem] tracking-tight whitespace-pre-line ${textCls}`}
              >
                {t(`bonus-page.conditions.${step}`)}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Promo;
